<template>
  <div>
    <div class="card-subtitle">
      <i class="icon-expand"></i>
      <div class="subtitle">Key values</div>
    </div>
    <div class="key-values p-x-4 p-b-4">
      <slot />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.key-values {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
</style>
